import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-popup-footer',
    templateUrl: './popup-footer.component.html',
    styleUrls: ['./popup-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
